<template>
    <div class="profile-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="profile-info d-flex align-items-center">
                            <img class="w-25 rounded-4" src="../../assets/images/profile-img.jpg" alt="profile-img">
                            <div class="profile-name ms-4">
                                <h4>John Smilga</h4>
                                <span>Member Since: September 2022</span>
                                <div class="follow-email">
                                    <button class="btn btn-primary">
                                        Follow
                                    </button>
                                    <a href="mailto:johnsmilga@gmail.com" class="btn btn-secondary">
                                        E-mail
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-sm-6">
                                <div class="profile-activity">
                                    <i class='bx bx-repost'></i>
                                    <h3>Posts</h3>
                                    <h2>15,2015</h2>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <div class="profile-activity">
                                    <i class='bx bx-user' ></i>
                                    <h3>Followers</h3>
                                    <h2>40,5487</h2>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <div class="profile-activity">
                                    <i class='bx bx-wifi'></i>
                                    <h3>Following</h3>
                                    <h2>50,1248</h2>
                                </div>
                            </div>
                        </div>

                        <div class="text-end edit-massage">
                            <router-link to="/edit-profile" class="btn btn-primary">
                                Edit Profile
                            </router-link>
                            <button class="btn btn-secondary">
                                Massage
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-details card-box-style">
                <ul class="list-inline profile-menu">
                    <li>
                        <router-link to="/profile">Profile</router-link>
                    </li>
                    <li>
                        <router-link to="/friends">Friends</router-link>
                    </li>
                    <li>
                        <router-link to="/followers">Followers</router-link>
                    </li>
                </ul>

                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-1.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Edward Mccoy</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1981
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-2.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Donald Kirklin</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1982
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-3.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Charles Coyle</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1983
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-4.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Nan Sepulveda</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1986
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-5.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Megan Hopes</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1980
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-7.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Luis Dubois</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1984
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-8.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Bernard Martinez</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1984
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-9.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Juhon Mccoy</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1985
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-10.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Kilva Mccoy</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1987
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-11.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Khakon Dew</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1981
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-12.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Anne Mari</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1988
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="single-friend">
                            <img src="../../assets/images/friends/friend-1.jpg" alt="friend-1">
    
                            <div class="friend-content">
                                <div class="d-flex justify-content-between align-items-center align-items-center">
                                    <h3>
                                        <router-link to="/profile">Edward Mccoy</router-link>
                                    </h3>
    
                                    <div class="team-social">
                                        <a href="#" class="control">
                                            <i class="ri-share-fill"></i>
                                        </a>
    
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/" target="_blank">
                                                    <i class="ri-facebook-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/" target="_blank">
                                                    <i class="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/" target="_blank">
                                                    <i class="ri-linkedin-fill"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/" target="_blank">
                                                    <i class="ri-twitter-fill"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
    
                                <ul class="info">
                                    <li>
                                        <a href="tel:+1-719-504-1984">
                                            <i class="ri-phone-fill"></i>
                                            +1 719-504-1984
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@joxi.com">
                                            <i class="ri-mail-line"></i>
                                            info@joxi.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="pagination-area">
                            <a href="/blog" class="next page-numbers">
                                <i class="ri-arrow-left-line"></i>
                            </a>
                            <span class="page-numbers current" aria-current="page">1</span>
                            <a href="/blog" class="page-numbers">2</a>
                            <a href="/blog" class="page-numbers">3</a>

                            <a href="/blog" class="next page-numbers">
                                <i class="ri-arrow-right-line"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FriendsContent'
}
</script>

<style lang="scss">
.single-friend {
	margin-bottom: 24px;
	position: relative;
	z-index: 1;
	img {
		border-radius: 8px 8px 0 0;
	}
	.friend-content {
		background-color: var(--white-color);
		box-shadow: var(--box-shadow);
		padding: 30px;
		border-radius: 0 0 8px 8px;
		h3 {
			font-size: 18px;
			margin-bottom: 0;
			a {
				color: var(--heading-color);
				&:hover {
					color: var(--main-color);
				}
			}
		}
		.team-social {
			position: relative;
			z-index: 1;
			.control {
				width: 40px;
				height: 40px;
				line-height: 42px;
				font-size: 20px;
				text-align: center;
				position: relative;
				color: var(--white-color);
				z-index: 1;
				display: inline-block;
				background-color: var(--main-color);
				border-radius: 8px;
			}
			ul {
				list-style-type: none;
				padding: 0;
				margin: 0;
				position: absolute;
				top: -200px;
				right: 0;
				opacity: 0;
				transition: var(--transition);
				li {
					a {
						i {
							width: 40px;
							height: 40px;
							line-height: 40px;
							background-color: var(--main-color);
							color: var(--white-color);
							font-size: 18px;
							text-align: center;
							transition: var(--transition);
							display: inline-block;
							margin-bottom: 10px;
							border-radius: 8px;
						}
						&:hover {
							i {
								background-color: var(--main-color);
							}
						}
					}
					&:nth-child(4) {
						a {
							i {
								transform: translateY(40px);
							}
						}
					}
					&:nth-child(3) {
						a {
							i {
								transform: translateY(80px);
							}
						}
					}
					&:nth-child(2) {
						a {
							i {
								transform: translateY(120px);
							}
						}
					}
					&:nth-child(1) {
						a {
							i {
								transform: translateY(160px);
							}
						}
					}
				}
			}
			&:hover {
				ul {
					opacity: 1;
					li {
						&:nth-child(4) {
							a {
								i {
									transform: translateY(0);
								}
							}
						}
						&:nth-child(3) {
							a {
								i {
									transform: translateY(0);
								}
							}
						}
						&:nth-child(2) {
							a {
								i {
									transform: translateY(0);
								}
							}
						}
						&:nth-child(1) {
							a {
								i {
									transform: translateY(0);
								}
							}
						}
					}
				}
			}
		}
		.info {
			padding-left: 0;
			margin-bottom: 0;
			list-style-type: none;
			margin-top: 15px;
			li {
				position: relative;
				padding-left: 25px;
				display: inline-block;
				margin-right: 10px;
				&:last-child {
					margin-right: 0;
				}
				a {
					i {
						position: absolute;
						top: -2.5px;
						left: 0;
						color: var(--main-color);
						font-size: 18px;
					}
				}
			}
		}
		.read-more {
			color: var(--heading-color);
			font-size: 14px;
			i {
				color: var(--heading-color) !important;
			}
			&:hover {
				color: var(--main-color);
				i {
					color: var(--main-color) !important;
				}
			}
		}
		.view-call {
			a {
				position: relative;
				padding-left: 25px;
			}
			i {
				position: absolute;
				top: 0;
				left: 0;
				color: var(--main-color);
				font-size: 18px;
			}
			.read-more {
				letter-spacing: normal;
				i {
					position: relative;
					top: 4px;
				}
			}
		}
	}
}
.profile-info {
	.w-25 {
		width: 120px !important;
	}
	h4 {
		font-size: 18px;
		margin-bottom: 10px;
	}
	span {
		font-size: 14px;
		display: block;
		margin-bottom: 20px;
	}
	.follow-email {
		.btn {
			&:last-child {
				margin-right: 0;
			}
			&.btn-primary {
				background-color: var(--main-color);
				margin-right: 20px;
			}
			&.btn-secondary {
				background-color: #5C31D6;
			}
		}
		
	}
}
.profile-activity {
	background-color: var(--white-color);
	box-shadow: var(--box-shadow);
	padding: 20px;
	text-align: center;
	border-radius: var(--border-radius);
	margin-bottom: 24px;
	i {
		font-size: 20px;
		width: 50px;
		height: 50px;
		line-height: 50px;
		display: inline-block;
		background-color: #5C31D6;
		text-align: center;
		color: var(--white-color);
		border-radius: 50px;
		margin-bottom: 20px;
	}
	h3 {
		font-weight: 600;
		font-size: 15px;
		margin-bottom: 10px;
	}
	h2 {
		font-size: 20px;
		font-weight: 700;
	}
}
.edit-massage {
	.btn {
		&:last-child {
			margin-right: 0;
		}
		&.btn-primary {
			background-color: var(--main-color);
			margin-right: 20px;
		}
		&.btn-secondary {
			background-color: #5C31D6;
		}
	}
	
}
.profile-details {
	padding: 100px !important;
	.profile-menu {
		margin-bottom: 0;
		border-bottom: 1px solid #eeeeee;
		padding-bottom: 20px;
		margin-bottom: 30px;
		li {
			display: inline-block;
			margin-right: 30px;
			&:last-child {
				margin-right: 0;
			}
			a {
				&:hover {
					color: var(--main-color);
				}
				&.active {
					color: var(--main-color);
				}
			}
		}
	}
	h3 {
		font-size: 18px;
		margin-bottom: 20px;
	}
	.personal-info {
		margin-bottom: 30px;
		ul {
			li {
				margin-bottom: 15px;
				span {
					font-weight: 600;
					font-size: 14px;
					color: var(--heading-color);
				}
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .profile-details {
        .profile-menu {
            margin-bottom: 20px;
        }
    }
    .edit-massage {
        .btn.btn-primary {
            margin-right: 0;
        }
    }
    .profile-info {
        display: block !important;
        text-align: center;
        img {
            margin-bottom: 10px;
        }
        .ms-4 {
            margin-left: 0 !important;
        }
        .follow-email {
            margin-bottom: 20px;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .profile-details {
        padding: 30px;
        .profile-menu {
            margin-bottom: 20px;
        }
    }
    .edit-massage {
        text-align: center !important;
        .btn.btn-primary {
            margin-right: 0;
        }
    }
    .profile-info {
        display: block !important;
        text-align: center;
        img {
            margin-bottom: 10px;
        }
        .ms-4 {
            margin-left: 0 !important;
        }
        .follow-email {
            margin-bottom: 20px;
        }
    }
}
</style>